<section
  class="landing-page-banner"
  aria-labelledby="landing-page-banner-title"
>
  <div class="banner-inner">
    <p id="landing-page-banner-title" class="banner-title">
      About SonderMind
    </p>
    <ul class="banner-metrics">
      <li class="banner-metric" *ngFor="let metric of metrics()">
        <span class="banner-icon" aria-hidden="true">
          <iris-icon
            [name]="metric.icon"
            [size]="iconSizes.SM"
            colorToken="$color-dec-green-50"
          />
        </span>
        <span class="banner-text">
          <span class="banner-value" *ngIf="metric.value">{{ metric.value }}</span>
          <span class="banner-label" [innerHTML]="metric.label"></span>
        </span>
      </li>
    </ul>
  </div>
</section>
